import { render, staticRenderFns } from "./indexPc.vue?vue&type=template&id=6dc68a68&scoped=true&"
import script from "./indexPc.vue?vue&type=script&lang=js&"
export * from "./indexPc.vue?vue&type=script&lang=js&"
import style0 from "./indexPc.vue?vue&type=style&index=0&id=6dc68a68&lang=less&scoped=true&"
import style1 from "./indexPc.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc68a68",
  null
  
)

export default component.exports